<template>
  <div>
    <diffSocket @push:data="pushData" :expiryDate="expiryDate"></diffSocket>
    <p class="title-diff">价差期权</p>
    <Row class="market2">
      <!-- <span>品种</span> -->
      <span>代码</span>
      <span>标的价格</span>
      <span @click="priceTypeChange"> {{ buyLabel }} </span>
      <span @click="priceTypeChange"> {{ saleLabel }} </span>
    </Row>
    <Row class="content-diff">
      <Row class="code" v-for="(item, index) in datas" :key="index" v-show="item.isShow || item.showId == showId">
        <!-- <span>{{ item.name ? item.name : '---'}}</span> -->
        <span @click="extendRow(item)">{{ item.underlying }}</span>
        <span :class="{ red: item.call , green: !item.call, black: item.put, del: item.isDel }" @click="extendRow(item)">{{ item.underlyingPrice }}</span>
        <span :class="{ red: item.call , green: !item.call, black: item.put, del: item.isDel }" @click="detailedPrice(item.code, item.buy, item.isDel, changeDate(expiryDate))">{{ lessThan(item.buyPrice, item) }}</span>
        <span :class="{ red: item.call , green: !item.call, black: item.put, del: item.isDel }" @click="detailedPrice(item.code, item.sale, item.isDel, changeDate(expiryDate))">{{ lessThan(item.sellPrice, item) }}</span>
      </Row>
    </Row>
  </div>
</template>

<script>
  import diffSocket from '@/components/home/diffSocket'
  export default {
    data() {
      return {
        datas: [],

        buyLabel: '买价',
        saleLabel:'卖价',

        showId: '',
      }
    },
    created() {
      
    },
    methods: {
      detailedPrice() {},
      priceTypeChange() {},
      pushData(data) {
        this.datas = this.groupData(data)
      },
      groupData(data) {
        if(!this.nowDate) return data
        let tradingDay = this.timeyy(this.nowDate).getTime()
        data = data.map(item => {
          let time = this.timeyy(this.dateFormat(item.quoteEffectiveDate)).getTime()    //报价有效期
          if(tradingDay > time) {
            item['isDel'] = true
          } else {
            item['isDel'] = false
          }
          item['isShow'] = true
          return item
        })
        let datas = []
        data.forEach(list => {
          datas.push(list)
          for(let i = 1; i < 4; i++) {
            if(list['spot' + i]) {
              let obj = {
                underlying: list['underlying' + i],
                underlyingPrice: list['spot' + i],
                showId: list.arbitrageQuoteId,
              }
              datas.push(obj)
            }
          }
        })
        return datas
      },

      extendRow(row) {
        if(this.showId != row.arbitrageQuoteId) {
          this.showId = row.arbitrageQuoteId
        } else {
          this.showId = ''
        }
      },

      
      // 处理数据
      lessThan(price, row) {
        if(!row.isShow) return ''
        if(!price) {
          return '---'
        } else if(row.isQuote == '0') {
          return '---'
        } else {
          return price
        }
      }
    },
    components: {
      diffSocket
    },
    watch: {
      nowDate(newValue, oldValue) {
        if(newValue) {
          this.groupData(this.datas)
        }
      }
    },
    props: ['expiryDate', 'nowDate'],     //当前所选中日期, 当前交易日
  }
</script>

<style scoped>
.market2 {
  z-index: 1;
  height: 2.25rem;
  line-height: 2.25rem;
  background-color: white;
  width: 100%;
  max-width: 750px;
}

.market2 span  {
  display: block;
  float: left;
  width: 20%;
  text-align: center;
  border-bottom: 1px solid #ccc;
}
.market2 span:first-of-type {
  width: 40%;
}
.code span:first-of-type {
  width: 40%;
}
.title-diff {
  text-align: center;
  font-weight: 800;
  color: red;
  font-size: 16px;
}
.content-diff {
  padding-bottom: 50px;
}
</style>